import React  from 'react'
import DropDown from '../dropdown';
import {Document} from '../../../api/services/next'

const DocumentTypeDropDown = ({...rest}) => {			
    return <DropDown search  api={Document.GetDocumentType} textField="Name" valueField="Id"  {...rest}/>
}

export default DocumentTypeDropDown